import MeWangEditor from './MeWangEditor.vue'
// 这里是重点
const cmp = {
  install: function(Vue){
    Vue.component(MeWangEditor.name, MeWangEditor)
  }
}

// 导出组件
export default cmp
